import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Swal from "sweetalert2";
import { apiService } from "../../../base/utils/service";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderUid: "",
      redirect: false,
      pending: false,
    };
  }
  componentDidMount() {
    console.log(window.history);
  }
  setOrder() {
    apiService(
      `v1/shops/${this.props.shopUid}/cart/finalize`,
      "put",
      this.props.params,
      true
    ).then((data) => {
      if (data && data.uid) {
        this.setState({ redirect: true });
      }
      console.log(data);
      if (
        data.response &&
        data.response.status &&
        data.response.status === 400 &&
        data.response.data.errors.address
      ) {
        Swal.fire({
          text: data.response.data.errors.address[0].message,
          showConfirmButton: false,
          toast: true,
          customClass: {
            htmlContainer: "text-center m-0",
          },
          timer: 3000,
          timerProgressBar: true,
        });
      }
    });
    // shopsCartFinalizeUpdate(this.props.shopUid, this.props.params).then(
    //   (items) => {
    //     items && this.setState({ redirect: true });
    //   }
    // );
  }

  footer_on_click() {
    if (this.props.params && this.props.type === "order") {
      this.setOrder();
    } else {
      this.setState({ redirect: true });
    }
  }
  render() {
    return (
      <footer
        className="row py-2-3 px-3 mx-0 position-fixed bg-white shadow-sm"
        style={{ bottom: "0", left: "0", right: "0", zIndex: "4" }}
      >
        {this.state.redirect &&
          (this.props.type === "invoic" ? (
            <Redirect push to={"/orders/" + this.state.orderUid} />
          ) : (
            <Redirect push to={this.props.path} />
          ))}
        <div className="col align-self-center">
          <button
            disabled={this.props.isDisabled || this.state.pending}
            className="btn rounded28 fs-6 px-3 py-2 bg-color-main text-white fw-bold"
            style={{ width: "135px" }}
            onClick={() => this.footer_on_click()}
          >
            {this.state.pending ? (
              <span
                className="spinner-border spinner-border-sm text-white"
                style={{ verticalAlign: "middle" }}
                role="status"
                aria-hidden="true"
              />
            ) : (
              this.props.btnText
            )}
          </button>
        </div>
        <div className="col-auto text-start">
          <p className="fs-7 text-muted mb-0">جمع کل</p>
          {this.props.payable_price && (
            <p className="fs-5 fw-bolder mb-0">
              {this.props.payable_price.title}
              <span className="fs-7 me-1">
                {this.props.payable_price.currency}
              </span>
            </p>
          )}
        </div>
      </footer>
    );
  }
}

export default Footer;
